import { render } from "./PagosList.vue?vue&type=template&id=57f2ba4e&scoped=true"
import script from "./PagosList.vue?vue&type=script&lang=js"
export * from "./PagosList.vue?vue&type=script&lang=js"

import "./PagosList.vue?vue&type=style&index=0&id=57f2ba4e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f2ba4e"]])

export default __exports__